<template>
  <PageContainer :class="$style.page">
    <template v-slot:body>
      <PkiCertificateList
        :tableData="pkiCertRecords"
      />
    </template>
  </PageContainer>
</template>

<script>
import {
  PageContainer,
} from '@jumpcloud/ui-components';
import PkiCertificateList from 'client/Pki/PkiCertificates/PkiCertificateList.vue';
// @todo remove import once api endpoint is set up
import { mockCertData } from 'client/Pki/Mock';

const pkiCertRecords = mockCertData;

export default {
  name: 'PkiCertificatePage',

  components: {
    PageContainer,
    PkiCertificateList,
  },

  data() {
    return {
      pkiCertRecords,
    };
  },
};
</script>

<style module scoped>
.page {
  background-color: var(--jcWhite50);
}
</style>
